import type { UseFetchOptions, UseFetchReturn } from "@vueuse/core";
import { type MaybeRef, toValue } from "vue";

import { useUserStore } from "@/stores/user.ts";
import type { GetUserPermissionsApi } from "@/types/permissions.ts";
import type { UserPreferences } from "@/types/userPreferences.ts";
import { authorizationApiClient } from "@/utils/apiClients.ts";

const useAccessInfo = (
  options: UseFetchOptions = { immediate: false },
): UseFetchReturn<GetUserPermissionsApi> => {
  const userStore = useUserStore();
  return authorizationApiClient("accessInfo", {
    ...options,
    afterFetch({ data }) {
      userStore.userPermissions = data;
      return { data };
    },
  }).json();
};

const useUserPreferences = (
  userPreferences: MaybeRef<Partial<UserPreferences>>,
  options: UseFetchOptions = { immediate: false },
): UseFetchReturn<unknown> => {
  const userStore = useUserStore();
  return authorizationApiClient("users/profile", {
    ...options,
    afterFetch(ctx) {
      userStore.preferences = {
        ...userStore.preferences,
        ...toValue(userPreferences),
      };
      return ctx;
    },
  }).post(() => {
    return toValue(userPreferences);
  });
};

export { useAccessInfo, useUserPreferences };
